﻿﻿export interface ITicketContactRequest {
    id: number;
    fullName: string;
    email: string;
}
